module.exports = __webpack_public_path__ + "static/img/home_buffer_photo1@2x.b5083ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_buffer_photo1@2x.png
// module id = PGK0
// module chunks = 0